import { categories } from "@/mocks/manga";

export default function CategorySection({ onSelect }: { onSelect: (name: string) => void }) {
  return (
    <section id="category" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
              <i className="ri-grid-line"></i> CATEGORY
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">题材分类</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              从热血战斗到日常治愈，从悬疑解谜到恋爱番外，按题材快速找到你感兴趣的火影同人漫画。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((cat) => (
            <button
              key={cat.name}
              type="button"
              onClick={() => onSelect(cat.name)}
              className="group flex flex-col items-start rounded-lg bg-background-50 p-5 text-left ring-1 ring-background-200/70 transition-all hover:-translate-y-1 hover:ring-primary-300"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-md text-background-50 ${cat.color}`}>
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-1 text-xs text-foreground-600">{cat.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600">
                {cat.count} 部作品 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}